import styled, { css } from 'styled-components/macro';
import { ControlWrapper } from '../controls.styled';
import { scaleIn } from '../controls.animation';

const sizeMap = {
  s: { box: 16, radius: 'xxxs', icon: 12 },
  m: { box: 24, radius: 'xxs', icon: 16 },
} as const;

export const StyledCheckbox = styled(ControlWrapper)`
  ${({ theme, $size }) => {
    const { box, radius, icon } = sizeMap[$size];

    return css`
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: ${box}px;
      min-height: ${box}px;
      max-width: ${box}px;
      max-height: ${box}px;
      background-color: ${theme.semantic.control.bg};
      color: ${theme.semantic.icon.onControl};
      border: 1px solid ${theme.semantic.border.control};
      border-radius: ${theme.radiuses[radius]};

      &:has(input:is(:checked, :indeterminate)) {
        background-color: ${theme.semantic.control.bgChecked};
        border-color: ${theme.semantic.control.borderChecked};
      }

      &:not(:has(input:disabled)):hover {
        background-color: ${theme.semantic.control.bgHover};
        border-color: ${theme.semantic.border.controlHover};
      }

      &:has(input:is(:checked, :indeterminate)):not(
          :has(input:disabled)
        ):hover {
        background-color: ${theme.semantic.control.bgCheckedHover};
        border-color: ${theme.semantic.control.borderCheckedHover};
      }

      &:has(input:disabled) {
        background-color: ${theme.semantic.control.bgDisabled};
        border-color: ${theme.semantic.border.disabled};
        color: ${theme.semantic.icon.onControlDisabled};
      }

      .icon-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        width: ${icon}px;
        height: ${icon}px;
        pointer-events: none;
        animation-name: ${scaleIn};
        animation-duration: ${theme.tokens.animation.duration.base};
        animation-timing-function: ${theme.tokens.animation.easing.elastic};
        animation-fill-mode: both;

        svg {
          width: 100%;
          height: 100%;
        }
      }
    `;
  }}
`;
